import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import APPConf from '../../lib/config/common';

export default () => { // Page403
  return (
    <Row>
      <Col lg={ 12 } style={ { paddingTop: '150px' } }>
        <h4 className='text-center'>{ APPConf.page403Text }</h4>
      </Col>
    </Row>
  );
};
